import { render } from "./DropDownMenu.vue?vue&type=template&id=51585c7e&scoped=true&ts=true"
import script from "./DropDownMenu.vue?vue&type=script&lang=ts"
export * from "./DropDownMenu.vue?vue&type=script&lang=ts"

import "./DropDownMenu.vue?vue&type=style&index=0&id=51585c7e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51585c7e"]])

export default __exports__